var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSaxFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H23.4015C23.7307 0 24 0.297307 24 0.660683V19.0937C24 19.5232 23.8204 19.9196 23.5212 20.1508L12.7182 28.971C12.2993 29.3013 11.7307 29.3013 11.2818 28.971L0.478803 20.1839C0.179551 19.9196 0 19.5232 0 19.1268V0.660683C0 0.297307 0.269327 0 0.598504 0H12Z",
    fill: "#EE8208"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5357 6.75935C21.984 4.99577 20.6496 2.75737 20.091 1.77384C19.191 0.247661 17.9186 1.09554 17.1118 2.72346C16.3049 4.35138 7.5556 25.3229 7.5556 25.3229",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5356 9.60817C20.8047 8.62464 20.2461 4.45308 19.1909 7.33586C18.6944 8.69247 11.5556 28.7318 11.5556 28.7318",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7778 24.349C6.67778 22.7889 8.17403 19.308 8.17403 16.4592C8.17403 14.4582 9.41537 11.9485 9.69468 11.2363C9.72571 11.1684 9.66364 11.1006 9.60157 11.1345L0.912191 13.8477C0.881158 13.8477 0.881158 13.9155 0.912191 13.9155C1.31563 14.1529 2.61903 15.2043 2.8673 16.4253C3.11557 17.8158 2.56362 20.6132 2.22225 21.4271",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2464 18.5278C11.7119 18.7652 12.0222 19.274 12.0222 19.8505C12.0222 20.6645 11.4326 21.3089 10.6878 21.3089C10.4705 21.3089 10.2843 21.241 10.0981 21.1732",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.798 14.7972C13.2635 15.0346 13.5738 15.5434 13.5738 16.1199C13.5738 16.9339 12.9842 17.5783 12.2394 17.5783C12.0532 17.5783 11.867 17.5444 11.6808 17.4426",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3495 11.1344C14.815 11.3718 15.1254 11.8805 15.1254 12.4571C15.1254 13.271 14.5357 13.9154 13.7909 13.9154C13.6047 13.9154 13.4185 13.8815 13.2634 13.7798",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaxFill);
export default __webpack_public_path__ + "static/media/icon-sax-fill.0160cb1410ca1e1461bb16cd71ebc511.svg";
export { ForwardRef as ReactComponent };